import {Button, VisuallyHidden, Wrap} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import {CloseIcon} from '../icons'
import React from 'react'
import PropTypes from 'prop-types'

/**
 * Renders the selected filters. Based on the original SelectedRefinements component.
 * @param {object} [containerProps]
 * @param {array} [filters]
 * @param {string} [resetLabel]
 * @param {function} [onRemove]
 * @param {function} [onReset]
 * @returns {JSX.Element}
 * @constructor
 */
const SelectedFilters = ({containerProps, filters, resetLabel, onRemove, onReset}) => {
    const {formatMessage} = useIntl()
    return (
        <Wrap
            direction="row"
            align="center"
            display="flex"
            spacing={0}
            shouldWrapChildren
            overflowX="auto"
            marginX={-4}
            paddingX={4}
            paddingTop={{lg: 2}}
            justifyContent={{lg: 'space-around'}}
            data-testid="sf-selected-refinements"
            sx={{
                '.chakra-wrap__list': {
                    flexWrap: {base: 'nowrap', lg: 'wrap'},
                    gap: 2,
                    justifyContent: 'center'
                }
            }}
            {...containerProps}
        >
            <Button variant="link" onClick={onReset} marginRight={{base: 2, lg: 4}}>
                {resetLabel ? (
                    resetLabel
                ) : (
                    <FormattedMessage
                        defaultMessage="Clear All"
                        id="global.filter_and_sort.action.clear_all"
                    />
                )}
            </Button>

            {filters?.map((filter, idx) => (
                <Button
                    key={idx}
                    variant="tag"
                    iconSpacing={3}
                    rightIcon={<CloseIcon boxSize={4} />}
                    onClick={onRemove && (() => onRemove(filter))}
                >
                    <VisuallyHidden>
                        {formatMessage(
                            {
                                id: 'global.removeFilter',
                                defaultMessage: 'Remove filter {filterName}'
                            },
                            {filterName: filter.label || filter}
                        )}
                    </VisuallyHidden>
                    <span aria-hidden="true">{filter.label || filter}</span>
                </Button>
            ))}
        </Wrap>
    )
}

SelectedFilters.propTypes = {
    containerProps: PropTypes.object,
    filters: PropTypes.array,
    resetLabel: PropTypes.string,
    onRemove: PropTypes.func,
    onReset: PropTypes.func
}

export default SelectedFilters
